import Vue from "vue";
import VueRouter, {RawLocation, Route} from "vue-router";
import scrollToHash from "../../global/scrollToHash";
import {ErrorNavOpts} from "~/models/navigableValidations/navigableValidation";
import IBreadcrumb from "~/interfaces/breadcrumbInterfaces";


export default class AppRouter extends VueRouter {
  // VueRouter does not expose this on api
  // so in order for typings to work
  // need to define on class
  matcher: any

  constructor(options, ...args) {
    super(options);
    this.afterEach(this.scrollHook)
    this.registerEvents();
  }

  scrollHook = async (to, from?) => {
    await Vue.nextTick();
    if (to.hash && to.hash !== '#') {
      if ($(encodeURI(to.hash)).length > 0) {
        await this.scrollTo(to);
      }
    }
  }

  scrollTo = (to: Route) => {
    $('body').promise().then(($el) => {
      $el.trigger('scrollToHash', {hash: to.hash});
    })
  }

  scrollToHashIfMatched(location) {
    const matched = this.matcher.match(location)
    if (matched) {
      this.scrollHook(matched);
    }
  }

  makeBreadcrumb(text: string = null, items: Array<IBreadcrumb> = null): Partial<IBreadcrumb> {
    return {
      text: text || this.currentRoute.name,
      url: this.currentRoute.fullPath,
      items: items
    }
  }

  // Vue Router overload
  async push(location: RawLocation | ErrorNavOpts): Promise<Route> {
    let loc = location;
    if (location instanceof ErrorNavOpts) loc = location.vueLocation
    try {
      return await super.push(loc)
    } catch (err) {
      if (err.name === "NavigationDuplicated") {
        this.scrollToHashIfMatched(loc)
      } else throw err;
    }
  }

  // Vue Router overload
  async replace(location: RawLocation | ErrorNavOpts): Promise<Route> {
    let loc = location;
    if (location instanceof ErrorNavOpts) loc = location.vueLocation
    try {
      return await super.replace(loc)
    } catch (err) {
      if (err.name === "NavigationDuplicated") {
        await this.scrollToHashIfMatched(loc)
      } else throw err;
    }
  }

  registerEvents() {
    $('body').on('scrollToHash', scrollToHash);
  };
}
